import Cookies from 'js-cookie'

export default {
  /**
   * Get session token
   */
  get () {
    return Cookies.get('session_token')
  },

  /**
   * Set session token
   * @param {string} token Session token
   */
  set (token) {
    Cookies.set('session_token', token, {
      expires: 365,
      secure: process.env.NODE_ENV === 'production'
    })
  },

  /**
   * Remove session token
   */
  remove () {
    Cookies.remove('session_token')
  }
}
